import { ActionIcon, useMantineColorScheme, useComputedColorScheme } from "@mantine/core"
import { IconSun, IconMoon } from "@tabler/icons-react"

interface ColorSchemeToggleProps {
  size?: "sm" | "md" | "lg"
}

export function ColorSchemeToggle({ size = "md" }: ColorSchemeToggleProps) {
  const { setColorScheme } = useMantineColorScheme()
  const computedColorScheme = useComputedColorScheme("light", { getInitialValueInEffect: true })

  const toggleColorScheme = () => {
    setColorScheme(computedColorScheme === "dark" ? "light" : "dark")
  }

  return (
    <ActionIcon
      variant="subtle"
      size={size}
      onClick={toggleColorScheme}
      aria-label={`Switch to ${computedColorScheme === "dark" ? "light" : "dark"} mode`}
      className={`transition-all duration-300 ${
        computedColorScheme === "dark"
          ? "text-yellow-400 hover:text-yellow-300 hover:bg-yellow-400/10"
          : "text-gray-600 hover:text-gray-800 hover:bg-gray-200/50"
      }`}
    >
      {computedColorScheme === "dark" ? <IconSun size={18} /> : <IconMoon size={18} />}
    </ActionIcon>
  )
}
